import type { ReactNode } from "react";

type Tone = "good" | "warn" | "bad" | "note";

const tones: Record<Tone, string> = {
  good: "bg-positive-tint border-positive/30 text-text",
  warn: "bg-warning-tint border-warning/40 text-text",
  bad: "bg-negative-tint border-negative/30 text-text",
  note: "bg-surface-high border-border text-text",
};

export function Banner({ tone = "note", children }: { tone?: Tone; children: ReactNode }) {
  return (
    <div
      role={tone === "bad" ? "alert" : undefined}
      className={`my-3.5 rounded-[var(--radius-card)] border px-4 py-[13px] text-[14px] leading-[1.5] ${tones[tone]}`}
    >
      {children}
    </div>
  );
}
